import { render, staticRenderFns } from "./SignTab.vue?vue&type=template&id=85e3cfd2&scoped=true"
import script from "./SignTab.vue?vue&type=script&lang=js"
export * from "./SignTab.vue?vue&type=script&lang=js"
import style0 from "./SignTab.vue?vue&type=style&index=0&id=85e3cfd2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e3cfd2",
  null
  
)

export default component.exports